import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const doctorVisitListApi = async (data) => {
  const endPoint = `admin/doctor-visit/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
